
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Box, Button, Flex, Heading, Text } from 'rebass/styled-components'
import { IProperties } from './types';
import { Item } from './Item';
import { useState } from 'react';
import Modal from 'styled-react-modal';
import { SpecialModalBackground } from '../../../components/Commons';
interface IProps {
  tree: Array<IProperties>
  setTree: (e: any) => void,
  lastTemplateEdit?: string
}
const MainDroppable: React.FC<IProps> = ({ tree, setTree, lastTemplateEdit }) => {
  const [showMustInherit, setShowMustInherit] = useState(false)
  return (
    <Droppable droppableId="characters">
      {(provided2, snapshot) => {
        return (
          <div
            ref={provided2.innerRef}
            {...provided2.droppableProps}
            id={'toto'}
            style={{ minHeight: '100%', width: '100%', padding: '12px', border: snapshot.isDraggingOver ? '1px dashed rgb(134, 180, 134)' : '1px solid #d7d7d7' }}
          >
            {(!tree ||
              tree.length < 1) ? (
              <Flex style={{ width: '100%', height: '100%', background: '#f7f7f7' }} justifyContent={'center'} alignItems={'center'} flex={1} id="rtt">
                <Text fontWeight={500} fontSize={'20px'} style={{ opacity: 0.3 }}>
                  Drag here to add
                </Text>
              </Flex>
            ) : (
              <>
                {tree.map((x, i) => {
                  return (
                    <Draggable key={x.id} draggableId={x.id} index={i} >
                      {(provided, snapshot) => (
                        <Flex flexDirection={'row'} mb={2} key={`mainDropTree${x.id}`} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                          <Item
                            lastTemplateEdit={lastTemplateEdit}
                            treeItem={x}
                            saveProperties={(p) => {
                              const ind = tree.findIndex((xx) => xx.id === x.id);
                              const tr = JSON.parse(JSON.stringify(tree));
                              tr[ind].params = p;
                              setTree(tr);
                            }}
                            onDelete={() => {
                              if (x.params.mustBeInherited) {
                                setShowMustInherit(true)
                                return
                              }
                              const t = JSON.parse(JSON.stringify(tree));
                              if (i > -1) {
                                t.splice(i, 1);
                              }
                              setTree(t);
                            }}
                          />
                        </Flex>
                      )}
                    </Draggable>
                  );
                })}
              </>
            )}
            {!!showMustInherit && (
              <Modal
                isOpen={true}
                onBackgroundClick={() => {
                  setShowMustInherit(false);
                }}
                onEscapeKeydown={() => {
                  setShowMustInherit(false);
                }}
              >
                <SpecialModalBackground
                  onClick={() => {
                    setShowMustInherit(false);
                  }}
                >
                  <Box
                    style={{
                      margin: '0 auto',
                      alignSelf: 'center',
                      borderRadius: '20px',
                      position: 'relative',
                      background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                      padding: '24px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      maxWidth: '95vw',
                      minWidth: 'initial',
                      maxHeight: '95vh',
                      minHeight: 'auto',
                      overflowY: 'hidden',
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <Flex flexDirection={'column'}>
                      <Heading textAlign={'center'} mb={4}>
                        Field must be inherited
                      </Heading>
                      <Text mb={3}>This field has been marked as <span style={{ fontStyle: 'italic' }}>Must be inherited</span> on the template by its creator</Text>
                      <Text mb={4}>Those field <span style={{ textDecoration: 'underline' }}>cannot be removed</span> from forms. You can however move it anywhere in your flow or change its description</Text>
                      <Button variant={'primary'} mt={4} alignSelf={'center'} onClick={() => setShowMustInherit(false)}>
                        OK
                      </Button>
                    </Flex>
                  </Box>
                </SpecialModalBackground>
              </Modal>
            )}
          </div>
        );
      }}
    </Droppable>)

}
export default MainDroppable